import registrationInstance from '../instance'

const getExpertCartSettings = (module) => {
  return registrationInstance.get(`/company/expert/cartSettings/${module}`,
  )
}

export default getExpertCartSettings
